import type { LinkUnitToCourseServiceConfig, UnlinkUnitFromCourseServiceConfig } from '@/services/httpServices/CourseServices/types';
import type {
  DeleteSequenceServiceConfig,
  GetSequenceByIdServiceConfig,
  InstructionFeedbackServiceConfig,
  PatchSequenceServiceConfig,
  SequenceChangelogServiceConfig,
  SequenceListServiceConfig,
  SynthesizeSpeechServiceConfig,
  TranslateSequenceServiceConfig,
  UpdateSequenceServiceConfig,
} from '@/services/httpServices/SequenceServices/types';

import { createQueryKey } from './queryKeyUtils';

export function sequenceListKeys(params?: SequenceListServiceConfig) {
  return createQueryKey(['sequenceList'], params);
}

/**
 * Creates a unique query key for infinite sequence list queries
 * Includes 'infinite' prefix to differentiate from regular list queries
 */
export function infiniteSequenceListKeys(params?: SequenceListServiceConfig) {
  return ['infinite', ...sequenceListKeys(params)];
}

export function sequenceByIdKeys(
  params?:
    | GetSequenceByIdServiceConfig
    | DeleteSequenceServiceConfig
    | TranslateSequenceServiceConfig
    | UpdateSequenceServiceConfig
    | UnlinkUnitFromCourseServiceConfig
    | LinkUnitToCourseServiceConfig
    | SynthesizeSpeechServiceConfig
    | InstructionFeedbackServiceConfig
    | PatchSequenceServiceConfig
    | LinkUnitToCourseServiceConfig
    | UnlinkUnitFromCourseServiceConfig,
) {
  return createQueryKey(['sequenceById'], params);
}

export function sequenceChangelogKeys(params?: SequenceChangelogServiceConfig) {
  return createQueryKey(['sequenceChangelog'], params);
}
